var _rect, _rect2, _rect3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEnterpriseAgreement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 37.25,
    width: 12,
    height: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 41.25,
    width: 12,
    height: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 45.25,
    width: 6,
    height: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.53223,11.47119A.753.753,0,0,0,68,11.25H60a.7502.7502,0,0,0-.75.75v7.68945L49,29.93945l-4.46973-4.46972A.74942.74942,0,0,0,44,25.25H30a.7502.7502,0,0,0-.75.75v2.18945l-8.5-8.5V14a.75027.75027,0,0,0-.21973-.53027l-2-2A.74942.74942,0,0,0,18,11.25H10a.7502.7502,0,0,0-.75.75V26a.7502.7502,0,0,0,.75.75H20a.7502.7502,0,0,0,.75-.75V21.81055l8.5,8.5v19.3789l-8.5,8.5V56a.75027.75027,0,0,0-.21973-.53027l-2-2A.74942.74942,0,0,0,18,53.25H10a.7502.7502,0,0,0-.75.75V68a.7502.7502,0,0,0,.75.75H20a.7502.7502,0,0,0,.75-.75V60.31055l8.5-8.5V54a.7502.7502,0,0,0,.75.75H50a.7502.7502,0,0,0,.75-.75V51.81055l8.5,8.5V68a.7502.7502,0,0,0,.75.75H70a.7502.7502,0,0,0,.75-.75V56a.75027.75027,0,0,0-.21973-.53027l-2-2A.74942.74942,0,0,0,68,53.25H60a.7502.7502,0,0,0-.75.75v4.18945l-8.5-8.5V32a.75027.75027,0,0,0-.21973-.53027L50.06055,31,59.25,21.81055V26a.7502.7502,0,0,0,.75.75H70a.7502.7502,0,0,0,.75-.75V14.01074a.75.75,0,0,0-.21777-.52881ZM19.25,25.25h-8.5V12.75h6.93945L19.25,14.31055Zm0,42h-8.5V54.75h6.93945L19.25,56.31055Zm25.5-39.43945L48.18945,31.25H44.75ZM49.25,53.25H30.75V26.75h12.5V32a.7502.7502,0,0,0,.75.75h5.25Zm11.5,1.5h6.93945L69.25,56.31055V67.25h-8.5Zm8.5-29.5h-8.5V12.75h6.93848L69.25,14.32031Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnterpriseAgreement);
export default __webpack_public_path__ + "static/media/icon_enterprise_agreement.84b29dfc77027498adf14714c11b74c3.svg";
export { ForwardRef as ReactComponent };